module.exports = __webpack_public_path__ + "static/media/weekly-report-icon-inactive.e063d472.svg";